import React from 'react'
import PropTypes from 'prop-types'
import { Grid, makeStyles } from '@material-ui/core'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydReadOnly from '../../../../commonDesign/SydReadOnly'
import { formatYesNo } from '../../../../../utils/formatters'

dayjs.extend(utc)

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: '1rem 0'
  },
  field: {
    marginBottom: '0.75rem'
  }
}))

const formatDate = (value) =>
  value ? dayjs.utc(value).format('MM/DD/YYYY') : '—'

const display = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  return value
}

function ReadOnlyField ({ label, children }) {
  const classes = useStyles()
  return (
    <SydLabel className={classes.field} label={label}>
      <SydReadOnly>{children}</SydReadOnly>
    </SydLabel>
  )
}

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node
}

function GeneralInfoTab ({ registration }) {
  const classes = useStyles()
  return (
    <div className={classes.panel}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <ReadOnlyField label='Long Name'>
            {display(registration.longName)}
          </ReadOnlyField>
          <ReadOnlyField label='First Name'>
            {display(registration.firstName)}
          </ReadOnlyField>
          <ReadOnlyField label='Last Name'>
            {display(registration.lastName)}
          </ReadOnlyField>
          <ReadOnlyField label='Orion Household ID'>
            {display(registration.orionClientId)}
          </ReadOnlyField>
          <ReadOnlyField label='Orion Registration Type ID'>
            {display(registration.orionRegistrationTypeId)}
          </ReadOnlyField>
        </Grid>
        <Grid item xs={12} md={6}>
          <ReadOnlyField label='Orion Firm Name'>
            {display(registration.orionFirmName)}
          </ReadOnlyField>
          <ReadOnlyField label='Orion Firm ID'>
            {display(registration.orionFirmId)}
          </ReadOnlyField>
          <ReadOnlyField label='Orion Registration ID'>
            {display(registration.orionRegistrationId)}
          </ReadOnlyField>
          <ReadOnlyField label='Is Active'>
            {formatYesNo(registration.isActive)}
          </ReadOnlyField>
          <ReadOnlyField label='Orion Sleeve'>
            {formatYesNo(registration.orionSleeve)}
          </ReadOnlyField>
          <ReadOnlyField label='Is Active Sleeve'>
            {formatYesNo(registration.isActiveSleeve)}
          </ReadOnlyField>
          <ReadOnlyField label='Modified'>
            {formatDate(registration.modifiedDate)}
          </ReadOnlyField>
        </Grid>
      </Grid>
    </div>
  )
}

GeneralInfoTab.propTypes = {
  registration: PropTypes.object.isRequired
}

export default GeneralInfoTab
